import { csvHeader } from '../../../../src/services/import-export/constants';
import { ImportExportLevel, ImportExportOption } from '../../../../src/services/import-export/public_model';
import { LevelsAsNumber, OptionItemObject } from '../../../../src/shared_models/interfaces';
import { LevelsInfo } from '../interfaces';

export const toJson = (data: OptionItemObject[], levelsInfo: LevelsInfo) =>
    JSON.stringify(
        {
            version: '1.0.0',
            firstLevel: mapToLevel(data, levelsInfo, 0),
        },
        null,
        4
    );

const mapToLevel = (
    items: OptionItemObject[],
    levelsInfo: LevelsInfo,
    depth: number,
    parentOptionKey?: string
): ImportExportLevel => {
    const levelInfo = getLevelInfoForOption(`_${depth + 1}` as LevelsAsNumber, levelsInfo, parentOptionKey);
    return {
        levelName: levelInfo?.levelName,
        description: levelInfo?.levelDescription,
        options: items.map(item => mapToOptions(item, levelsInfo, depth)),
    };
};

const mapToOptions = (item: OptionItemObject, levelsInfo: LevelsInfo, depth: number): ImportExportOption => ({
    value: item.value,
    id: item.key,
    isDefault: item.isDefaultOption,
    isEnabled: item.isEnabled,
    nestedLevel: item.children.length ? mapToLevel(item.children, levelsInfo, depth + 1, item.key) : undefined,
});

export const toCsv = (data: OptionItemObject[], levelsInfo: LevelsInfo) => {
    const dataRows = reduceLevelToRows(data, levelsInfo, 0);
    return [csvHeader, ...dataRows].map(row => row.join(',')).join('\n');
};

const reduceLevelToRows = (items: OptionItemObject[], levelsInfo: LevelsInfo, depth: number, parentOptionKey?: string) => {
    return items.reduce((acc, item) => {
        addRowToAcc(acc, item, levelsInfo, depth, parentOptionKey);
        acc.push(...reduceLevelToRows(item.children, levelsInfo, depth + 1, item.key));
        return acc;
    }, [] as string[][]);
};

const addRowToAcc = (
    acc: string[][],
    { key, value, isEnabled, isDefaultOption }: OptionItemObject,
    levelsInfo: LevelsInfo,
    depth: number,
    parentOptionKey?: string
) => {
    const row = getEmptyCsvRow();
    const levelInfo = getLevelInfoForOption(`_${depth + 1}` as LevelsAsNumber, levelsInfo, parentOptionKey);
    if (levelInfo) {
        row[7] = levelInfo.levelName;
        row[8] = levelInfo.levelDescription;
    }
    row[depth] = value;
    row[9] = `${isDefaultOption}`;
    row[10] = `${isEnabled}`;
    row[11] = key;
    acc.push(row);
};

const getEmptyCsvRow = () => Array(12).fill('') as string[];

const getLevelInfoForOption = (depth: LevelsAsNumber, levelsInfo: LevelsInfo, parentOptionKey?: string) => {
    return depth === '_1' ?
            levelsInfo['_1'].slice(-1)[0]?.levelInfo
        :   levelsInfo[depth].find(info => info.parentOptionKey === parentOptionKey)?.levelInfo;
};
